import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PortalAuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0] || "";
    axios.post(`${API}/portal/auth/google`, { session_id: sessionId }, { withCredentials: true })
      .then(({ data }) => {
        if (data.profile_complete === false) {
          navigate("/portal/profile", { state: { user: data, completeProfile: true }, replace: true });
        } else {
          navigate("/portal", { state: { user: data }, replace: true });
        }
      })
      .catch(() => navigate("/portal/auth", { state: { error: "Google sign-in failed. Please try again or use email." }, replace: true }));
  }, [location, navigate]);
  return null;
}
